import countries from "@/constants/countries.json";

const getSelectedCountry = (inputPhone: string = "") => {
  return countries.find((country) => {
    // Make sure country has phone codes array
    if (
      !country.phone ||
      !Array.isArray(country.phone) ||
      country.phone.length === 0
    ) {
      return false;
    }

    // Skip empty inputs
    if (!inputPhone) {
      return false;
    }

    // Ensure input has + prefix for comparison
    const normalizedInput = (inputPhone as string).startsWith("+")
      ? inputPhone
      : "+" + inputPhone;

    // Check if any country code is a prefix of the input phone number
    return country.phone.some((phoneCode) => {
      // Special case: if the phone code is just "+" (like Antarctica)
      if (phoneCode === "+") {
        // Only match if input is exactly "+" (not allowing any digits after)
        return normalizedInput === "+";
      }

      // For normal country codes, check if the input starts with the phone code
      return (normalizedInput as string).startsWith(phoneCode);
    });
  });
};

export default getSelectedCountry;
